var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var $ = require("./lib/qsa");
var dot = require("./lib/dot");
var templateSource = require("./_content.html");
var template = dot.compile(templateSource);

async function init(pymChild) {
  if (window.location.hostname == "apps.npr.org") {
    var request = await fetch("https://apps.npr.org/dailygraphics/data/sheets/2024-political-calendar-20230829.json");
    // console.log(request); 
    var copy = await request.json();
    var data = formatData(copy);
    var content = template(data);
    var graphicEl = $.one("#graphic-table");

    graphicEl.innerHTML = content;
    setupIntersectionObserver();
    setupFixedTimeline();

  }
  pymChild.sendHeight();
}

/*====================*/
// create subarrays of months
/*====================*/
function formatData(data) {
  if (!data || !data.data || !Array.isArray(data.data)) {
    console.error('Invalid data structure');
    return { processedData: [], yearEvents: [] };
  }

  const filtered = data.data.filter(d => d.which_calendar === "both");

  filtered.sort((a, b) => new Date(a.date) - new Date(b.date));

  let currentYear = null;
  let yearEventCount = 0;
  let yearEvents = [];
  let previousMonth = null;
  let processedData = [];

  filtered.forEach((row, index) => {
    const date = new Date(row.date);
    const year = date.getFullYear();
    const month = date.getMonth();

    if (year !== currentYear) {
      if (currentYear !== null) {
        yearEvents.push({ year: currentYear, count: yearEventCount });
      }
      currentYear = year;
      yearEventCount = 0;
      previousMonth = null;
    }

    yearEventCount++;

    const isDifferentMonth = month !== previousMonth;

    processedData.push({
      ...row,
      year,
      expandedState: row.expanded_or_collapsed || 'collapsed',
      isDifferentMonth,
      elementClass: `element-row ${row.optional_class} ${isDifferentMonth ? 'different-month' : ''}`
    });

    previousMonth = month;
  });

  if (currentYear !== null) {
    yearEvents.push({ year: currentYear, count: yearEventCount });
  }

  return {
    ...data,
    processedData,
    yearEvents
  };
}

/*====================*/
/*Set up itnersection observer for the fixed timeline
/*====================*/
function setupIntersectionObserver() {
  const elementRows = document.querySelectorAll('.element-row');
  const fixedTimeline = document.querySelector('.fixed-timeline');
  const timelineContent = document.querySelector('.timeline-content');
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let visibleRows = [];

  // Define the offset (e.g., 100px from the top)
  const offset = 300;

  const observer = new IntersectionObserver((entries) => {
    // Update the list of visible rows
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visibleRows.push(entry.target);
      } else {
        visibleRows = visibleRows.filter(row => row !== entry.target);
      }
    });

    // Sort visible rows by their position on the page
    visibleRows.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

    // Determine scroll direction
    const st = window.pageYOffset || document.documentElement.scrollTop;
    const isScrollingDown = st > lastScrollTop;
    lastScrollTop = st;

    // Choose the appropriate row to update the timeline
    let targetRow;
    if (visibleRows.length > 0) {
      if (isScrollingDown) {
        // When scrolling down, use the second visible row if available
        targetRow = visibleRows[Math.min(1, visibleRows.length - 1)];
      } else {
        // When scrolling up, use the second-to-last visible row if available
        targetRow = visibleRows[Math.max(0, visibleRows.length - 2)];
      }
      updateFixedTimeline(targetRow);
    }
  }, { 
    threshold: 0.3,
    rootMargin: `-${offset}px 0px 0px 0px` // This creates the offset from the top
  });

  elementRows.forEach(row => observer.observe(row));

  // Setup for fixed timeline positioning
  const contentObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        fixedTimeline.classList.add('fixed');
      } else {
        fixedTimeline.classList.remove('fixed');
      }
    });
  }, { 
    threshold: 0.3,
    rootMargin: `-${offset}px 0px 0px 0px` // Apply the same offset to this observer
  });

  contentObserver.observe(timelineContent);
}

/*====================*/
/* Update the fixed timeline for the graphic
/*====================*/
function updateFixedTimeline(target) {
  const container = document.querySelector('.timeline-content');
  const fixedTimeline = document.querySelector('.fixed-timeline');
  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  
  // Use requestAnimationFrame for smooth position updates
  requestAnimationFrame(() => {
    const fixedTimelineOffset = (targetRect.top - containerRect.top) - 200;
    fixedTimeline.style.transform = `translateY(${fixedTimelineOffset}px)`;
  });

  // Remove active class from all month items and year items
  const allMonthItems = document.querySelectorAll('.fixed-timeline .month-item');
  const allYearItems = document.querySelectorAll('.fixed-timeline .year-item');
  allMonthItems.forEach(item => item.classList.remove('active'));
  allYearItems.forEach(item => item.classList.remove('active'));

  // Add active class to the current month item and its parent year item
  const currentMonth = target.dataset.month;
  const currentYear = target.dataset.year;
  const activeMonthItem = document.querySelector(`.fixed-timeline .month-item[data-month="${currentMonth}"][data-year="${currentYear}"]`);
  if (activeMonthItem) {
    activeMonthItem.classList.add('active');
    const activeYearItem = activeMonthItem.closest('.year-item');
    if (activeYearItem) {
      activeYearItem.classList.add('active');
    }

    // Smooth scroll the fixed timeline to show the active year
    const scrollPosition = activeYearItem.offsetTop - fixedTimeline.offsetHeight / 2;
    fixedTimeline.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }
}


/*====================*/
/* set up the click event handler for the fixed timeline, and the scroll habdler for the big timeline
/*====================*/
function setupFixedTimeline() {
  const monthItems = document.querySelectorAll('.fixed-timeline .month-item');
  monthItems.forEach(item => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const month = item.dataset.month;
      const year = item.dataset.year;
      const elementRow = document.querySelector(`.timeline-content .element-row[data-month="${month}"][data-year="${year}"]`);
    });
  });
  const timelineContent = document.querySelector('.timeline-content');
}

var onWindowLoaded = function () {
  pym.then(child => {
    init(child);
    child.sendHeight();
    setupIntersectionObserver();
    setupFixedTimeline();

    child.onMessage("on-screen", function (bucket) {
      ANALYTICS.trackEvent("on-screen", bucket);
    });
    child.onMessage("scroll-depth", function (data) {
      data = JSON.parse(data);
      ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
    });

    window.addEventListener("resize", () => child.sendHeight());
  });
}

// wait for images to load
window.onload = onWindowLoaded;
